import { c as _c } from "react/compiler-runtime";
import { PopoverFullPropertiesType } from "@website/ui/popover-full/popover-full.types";
import { MouseEvent, useEffect, useEffectEvent, useRef, useState } from "react";
export const usePopoverFull = properties => {
  const $ = _c(18);
  const rootReference = useRef(null);
  const {
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby,
    id,
    animate,
    open,
    onClose
  } = properties;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [animateOpen, setAnimateOpen] = useState(false);
  const closePopover = useEffectEvent(onClose);
  let t0;
  if ($[0] !== animate || $[1] !== closePopover || $[2] !== open) {
    t0 = () => {
      let animationTimeout;
      const checkIfClickedOutside = t1 => {
        const {
          target
        } = t1;
        if (open && rootReference.current && !rootReference.current.contains(target as Node)) {
          closePopover?.();
        }
      };
      if (document) {
        if (open) {
          document.addEventListener("click", checkIfClickedOutside, true);
          setPopoverOpen(true);
          animationTimeout = setTimeout(() => {
            setAnimateOpen(true);
          }, 0);
        } else {
          document.removeEventListener("click", checkIfClickedOutside, true);
          setAnimateOpen(false);
          animationTimeout = setTimeout(() => {
            setPopoverOpen(false);
          }, animate === "normal" ? 0 : 75);
        }
      }
      return () => {
        if (animationTimeout !== undefined) {
          clearTimeout(animationTimeout);
        }
        if (document) {
          document.removeEventListener("click", checkIfClickedOutside, true);
        }
      };
    };
    $[0] = animate;
    $[1] = closePopover;
    $[2] = open;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== animate || $[5] !== open) {
    t1 = [animate, open];
    $[4] = animate;
    $[5] = open;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  const stopPropagationOnModal = _temp;
  let t2;
  if ($[7] !== ariaDescribedby || $[8] !== ariaLabelledby || $[9] !== id) {
    t2 = {
      "aria-labelledby": ariaLabelledby,
      "aria-describedby": ariaDescribedby,
      "aria-modal": true,
      onClick: stopPropagationOnModal,
      ref: rootReference,
      role: "dialog",
      tabIndex: 0,
      id
    };
    $[7] = ariaDescribedby;
    $[8] = ariaLabelledby;
    $[9] = id;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = animate === "normal" ? 0 : 75;
  let t4;
  if ($[11] !== t3) {
    t4 = {
      timeout: t3
    };
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== animateOpen || $[14] !== popoverOpen || $[15] !== t2 || $[16] !== t4) {
    t5 = {
      rootProps: t2,
      transitionProps: t4,
      popoverOpen,
      animateOpen
    };
    $[13] = animateOpen;
    $[14] = popoverOpen;
    $[15] = t2;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
function _temp(event) {
  event.stopPropagation();
}